export enum PATH {
    STATUS = 'status',
    VEHICLES = 'vehicles',
    BILLING = 'billing',
    STATISTICS = 'statistics',
    USER_MANAGEMENT = 'user-management',
    PARKING_MANAGEMENT = 'parking-management',
    PROFILE = 'profile',
    ACTIONS = 'actions',
    PAY_STATIONS = 'pay-stations',
    VALIDATION = 'validation',
    CASH_COLLECTIONS = 'cash-collections',
    PARKING_ADMIN = 'parking-admin',
}
